import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-retired-course',
    templateUrl: './retired-course.component.html',
    styleUrls: ['./retired-course.component.scss'],
    standalone: false
})

export class RetiredCourseComponent implements OnInit {
  @Input() course: any = {};
  translations: any;

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }
}
